module.exports = __webpack_public_path__ + "static/img/novalloy-plus-dedication-plaque04.9344ed5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/novalloy-plus/novalloy-plus-dedication-plaque04.jpg
// module id = 832
// module chunks = 0